/** Fixed labels and bounded rolling timing windows; sorting happens only on demand. */
export class LiveTimings {
    constructor(labels, size = 512) {
        if (!Number.isInteger(size) || size < 1 || size > 4096) throw new Error("Invalid timing window");
        this.windows = new Map(labels.map(label => [label, { values: new Float64Array(size), cursor: 0, count: 0 }]));
    }
    record(label, milliseconds) {
        const window = this.windows.get(label);
        if (!window) throw new Error("Unknown timing label");
        if (!Number.isFinite(milliseconds) || milliseconds < 0) return;
        window.values[window.cursor] = milliseconds;
        window.cursor = (window.cursor + 1) % window.values.length;
        window.count = Math.min(Number.MAX_SAFE_INTEGER, window.count + 1);
    }
    reset() {
        for (const window of this.windows.values()) { window.cursor = 0; window.count = 0; }
    }
    summary() {
        const result = {};
        for (const [label, window] of this.windows) {
            const values = Array.from(window.values.subarray(0, Math.min(window.count, window.values.length))).sort((a, b) => a - b);
            result[label] = { count: window.count, windowCount: values.length,
                p95: values.length ? values[Math.ceil(values.length * 0.95) - 1] : null,
                max: values.length ? values.at(-1) : null,
                mean: values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null };
        }
        return result;
    }
}
